import React from 'react';
import {
  Icon, IconName,
} from '@usealloy/component-library';
import {
  defaultOnCopyAction, defaultOnDeleteAction, defaultOnSwapAction, defaultOnUpdateAction,
} from './helpers';


export const OnCopyDefaults = {
  label: 'Copy',
  Icon: null,
  style: null,
  onSelect: defaultOnCopyAction,
};

export const OnDeleteDefaults = {
  label: 'Delete',
  Icon: <Icon icon={IconName.Trash} color="var('--cl-red-600)" />,
  style: { color: 'var(--cl-red-600)' },
  onSelect: defaultOnDeleteAction,
};

export const OnSwapDefaults = {
  label: 'Swap Tag',
  Icon: null,
  style: null,
  onSelect: defaultOnSwapAction,
};

export const OnUpdateDefaults = {
  label: 'Update to active version',
  Icon: null,
  style: null,
  onSelect: defaultOnUpdateAction,
};
